import axios from './axiosConfig'
import type {
  HospitalListBody,
  SearchHospitalBody,
  HospitalListResponse,
  HospitalDeleteBody,
  HospitalDeleteResponse,
  // HospitalCreateBody,
  HospitalCreateResponse
} from '@/types'

export const searchHospitalService = (data?: SearchHospitalBody): Promise<any> => {
  return axios.post('/hospital/getHospitals', data)
}

export const getHospitalListService = (data: HospitalListBody): Promise<HospitalListResponse> => {
  return axios.post('/hospital/getHospitalsPaging', data)
}

export const deleteHospitalService = (data: HospitalDeleteBody): Promise<HospitalDeleteResponse> => {
  return axios.post('/hospital/deleteById', data)
}

export const createOrUpdateHospitalService = (
  data: any
): Promise<HospitalCreateResponse> => {
  return axios.post('/hospital/saveUpdateHospitalInfo', data)
}
